import z from "zod";

export const ButtonActions = [
  "toggleRightDrawer",
  "toggleLeftDrawer",
  "toggleBottomDrawer",
  "navigate",
  "navigatePrevious",
  "navigateNext",
  "showModal",
] as const;

export type ButtonActionType = typeof ButtonActions[number];
export const ButtonActionSchema = z.enum(ButtonActions);